module.exports = __webpack_public_path__ + "c47c4db191f0271c41f3ccf30666968d.svg";